/**
 * iframe 安全配置文件
 * 用於集中管理允許的父頁面域名和安全策略
 */

// 根據環境變量或默認值配置允許的父頁面域名
const getAllowedParentOrigins = () => {
  // 優先使用環境變量配置（生產環境必須配置）
  if (process.env.VUE_APP_ALLOWED_PARENT_ORIGINS) {
    return process.env.VUE_APP_ALLOWED_PARENT_ORIGINS.split(',').map(origin => origin.trim())
  }
  
  // 開發環境
  if (process.env.NODE_ENV === 'development') {
    return [
      // 'http://localhost:8080',
      // 'http://localhost:8081',
      // 'http://127.0.0.1:8080',
      // 'http://127.0.0.1:5500',
      // 'http://localhost:3001',
      // 可以添加更多開發環境域名
    ]
  }
  
  // 生產環境（如果未配置環境變量，使用默認值）
  if (process.env.NODE_ENV === 'production') {
    // ⚠️ 注意：生產環境應通過環境變量配置實際域名
    // 生產環境不輸出警告，避免控制台泄露信息
    return [
      'https://j26.taodining.com.tw', // 根據實際情況修改
      'https://www.taodining.com.tw/star2026',
      'http://47.95.209.68:9007'
      // 可以添加更多生產環境域名
    ]
  }
  
  // 默認（測試環境等）
  return [
    // 'http://localhost:8080',
    // 'http://127.0.0.1:8080',
    // 'http://localhost:3001',
  ]
}

// CSP frame-ancestors 配置
const getFrameAncestors = () => {
  // 優先使用環境變量配置
  if (process.env.VUE_APP_ALLOWED_PARENT_ORIGINS) {
    const origins = process.env.VUE_APP_ALLOWED_PARENT_ORIGINS.split(',').map(origin => origin.trim()).join(' ')
    return `'self' ${origins}`
  }
  
  if (process.env.NODE_ENV === 'development') {
    // return "'self' http://localhost:* http://127.0.0.1:* http://localhost:3001"
    return "'self' https://www.taodining.com.tw/star2026 https://j26.taodining.com.tw http://47.95.209.68:9007"
  }
  
  if (process.env.NODE_ENV === 'production') {
    // ⚠️ 注意：生產環境應通過環境變量配置實際域名
    // 生產環境不輸出警告，避免控制台泄露信息
    return "'self' https://j26.taodining.com.tw https://www.taodining.com.tw/star2026 http://47.95.209.68:9007" // 根據實際情況修改
  }
  
  return "'self' https://j26.taodining.com.tw https://www.taodining.com.tw/star2026 http://47.95.209.68:9007" // 根據實際情況修改
}

// 導出配置
export const securityConfig = {
  allowedParentOrigins: getAllowedParentOrigins(),
  frameAncestors: getFrameAncestors(),
  
  // 其他安全配置
  messageTimeout: 60000, // postMessage 消息有效期（毫秒）
  enableSignatureVerification: true, // 是否啟用簽名驗證
  
  // 日誌配置
  enableSecurityLogs: process.env.NODE_ENV === 'development', // 開發環境顯示安全日誌
}

export default securityConfig

